/**
* Converts workflow ID to more robust token
* @example <workflow-status workflow="{{ story.status.workflow }}" 
*                               raw="{{ story.status.workflowRaw }}">
*          </workflow-status>
* @example <workflow-status workflow="{{ trigger.oldWorkflowStatus }}">
*          </workflow-status>
*/

function workflowStatus(schemaService, $translate) {
  function link($scope, element, attrs) {
    const scope = $scope;

    attrs.$observe('workflow', (workflow) => {
      schemaService.getWorkflowStatus(workflow)
        .then((response) => {
          if (angular.isDefined(response)) {
            scope.color = response.color;

            if (attrs.raw) {
              scope.workflowLabel = attrs.raw;
            } else {
              scope.workflowLabel = response.name;
            }
          } else {
            scope.workflowLabel = $translate.instant('UNKNOWN');
          }
        });
    });
  }

  return {
    restrict: 'E',
    scope: {},
    template: '<span ng-style="{ \'color\': color }">{{ workflowLabel }}</span>',
    link
  };
}

const directiveArr = [
  'schemaService',
  '$translate',
  workflowStatus
];

export default function (ngModule) {
  ngModule.directive('workflowStatus', directiveArr);
}
